/* eslint-disable prettier/prettier */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSearchParams } from 'react-router-dom';
import { Button, Col, Input, Row, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../app/hook';
import DashBoardDropdown from '../../components/dashboardComponents/DashBoardDropdown';
import DashBoardTable from '../../components/dashboardComponents/DashBoardTable';
import { GuestChart } from '../../components/dashboardComponents/guest';
import PieChart from '../../components/dashboardComponents/PieChart';
import NoDataBooking from '../../components/noDataComponent/noDataBooking';
import SectionLoader from '../../components/sectionLoader/sectionLoader';
import './dashboard.css';
import {
  downloadTableData,
  getTableSummary,
  getTotalBookings,
} from './dashboardSlice';
const Dashboard: React.FC = () => {
  const [month, setMonth] = useState(moment().format('YYYY-MM'));
  const [monthInTable, setMonthInTable] = useState(moment().format('YYYY-MM'));
  const [tableSearch, setTableSearch] = useState<string>('');
  const [tableFilter, setTableFilter] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [currency, setCurrency] = useState<string>('USD');
  const currencyOptions = [
    { value: 'USD', label: '$ USD' },
    { value: 'EUR', label: '€ EUR' },
  ];
  const { currentFacility, activeFacility } = useAppSelector(
    (state) => state.authentication
  );
  const {
    TotalBusiness,
    isTotalBookingsLoading,
    istableSummaryFetching,
    tableSummary,
    istableSummarydownloading,
  } = useAppSelector((state) => state.dasboardInfo);
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [translation] = useTranslation('common');
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!currentFacility?.id) {
      if (!searchParams.get('f_id')) {
        setSearchParams({ f_id: activeFacility?.id });
      }
    } else {
      setSearchParams({ f_id: currentFacility?.id });
    }
  }, [currentFacility?.id, activeFacility?.id, window.location.href]);
  useEffect(() => {
    dispatch(
      getTotalBookings({
        month,
        currency,
        facilityId: currentFacility?.id || (searchParams.get('f_id') as string),
      })
    );
  }, [month, currency]);
  useEffect(() => {
    dispatch(
      getTableSummary({
        month: monthInTable,
        searchTerm: tableSearch,
        filter: tableFilter,
        page: currentPage,
        facilityId: currentFacility?.id || (searchParams.get('f_id') as string),
      })
    );
  }, [monthInTable, tableSearch, tableFilter, currentPage]);
  const handleDateOnGraph = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMonth(moment(event.target.value).format('YYYY-MM'));
  };
  const handleDateOnTable = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPage(0);
    setTableFilter('');
    setMonthInTable(moment(event.target.value).format('YYYY-MM'));
  };
  const handleTableSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setCurrentPage(0);
    const form = event.currentTarget;
    const input = form.elements.namedItem('search') as HTMLInputElement;

    if (input) {
      setTableSearch(input.value);
    }
  };
  const currentDate = new Date();
  // get current month and date in some format
  const maxMonth = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, '0')}`;
  const hasBookings = !!TotalBusiness?.data?.[0]?.totalBookings;
  const Headerstyles = {
    fontSize: hasBookings ? '24px' : '80px',
    marginBottom: hasBookings ? '0px' : '20px',
  };
  const handleOnchange = (value: string) => {
    if (!value) {
      setTableSearch('');
    }
  };
  return (
    <div className=" user-page dashboard-wraper">
      <Row className="pt-4"></Row>
      <Row className="gx-4 gy-4 w-full chart-row">
        <Col lg={7} md={12}>
          <div className="first-graph ">
            {!isTotalBookingsLoading ? (
              <>
                <div className="total-bookings-heading-section">
                  <h3 className="tb-heading">
                    {translation('DASHBOARD.TOTAL_BOOKINGS')}
                  </h3>
                  <div className="tb-button-container">
                    <div className="month-picker-wraper">
                      <input
                        max={maxMonth}
                        onChange={(event) => handleDateOnGraph(event)}
                        className="month-picker-dashboard"
                        type="month"
                        value={month}
                      />
                      <div className="calender-image-container">
                        <img
                          width={24}
                          height={24}
                          src="/assets/calender.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <DashBoardDropdown
                      value={currency}
                      setValue={setCurrency}
                      options={currencyOptions}
                    />
                  </div>
                </div>
                <div className="total-booking-chart-section">
                  <div className="dashboard-pie">
                    <PieChart values={TotalBusiness?.data[0]} />
                    <div
                      style={{
                        border: hasBookings ? 'none' : '1px solid green',
                      }}
                      className="dashboard-pie-bookings"
                    >
                      <h6 style={Headerstyles}>
                        {TotalBusiness?.data[0]?.totalBookings
                          ? TotalBusiness?.data[0]?.totalBookings
                          : 0}
                      </h6>
                      <p>{translation('DASHBOARD.TOTAL_BOOKINGS')}</p>
                    </div>
                  </div>
                  <div className="pie-data">
                    <div>
                      <p>{translation('DASHBOARD.TOTAL_BOOKING_AMOUNT')}</p>
                      <h3>
                        {currency == 'USD' ? '$' : '€'}{' '}
                        {TotalBusiness?.data[0]?.totalEarnings.toFixed(2)
                          ? TotalBusiness?.data[0]?.totalEarnings.toFixed(2)
                          : 0}
                      </h3>
                    </div>
                    <div className="count-container">
                      <div>
                        <h4>
                          {TotalBusiness?.data[0]?.statusCounts?.CONFIRMED
                            ? TotalBusiness?.data[0]?.statusCounts?.CONFIRMED
                            : 0}
                        </h4>
                        <p className="confirmed">
                          {translation('DASHBOARD.CONFIRMED')}
                        </p>
                      </div>
                      <div>
                        <h4>
                          {TotalBusiness?.data[0]?.statusCounts?.CANCELED
                            ? TotalBusiness?.data[0]?.statusCounts?.CANCELED
                            : 0}
                        </h4>
                        <p className="canceled">
                          {translation('DASHBOARD.CANCELED')}
                        </p>
                      </div>
                      <div>
                        <h4>
                          {TotalBusiness?.data[0]?.statusCounts?.PENDING
                            ? TotalBusiness?.data[0]?.statusCounts?.PENDING
                            : 0}
                        </h4>
                        <p className="pending">
                          {translation('DASHBOARD.PENDING')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="first-grapg-loader">
                <ContentLoader width={400} height={250} viewBox="0 0 200 200">
                  <rect x="0" y="130" rx="2" ry="2" width="27" height="60" />
                  <rect x="40" y="115" rx="2" ry="2" width="27" height="75" />
                  <rect x="80" y="96" rx="2" ry="2" width="27" height="94" />
                  <rect x="120" y="50" rx="2" ry="2" width="27" height="140" />
                  <rect x="160" y="112" rx="2" ry="2" width="27" height="78" />
                </ContentLoader>
              </div>
            )}
          </div>
        </Col>
        {searchParams.get('f_id') && <GuestChart />}
      </Row>
      <Row className="table-Row">
        <div className="table-container">
          <div className="total-bookings-heading-section">
            <h3 className="tb-heading">
              {translation('DASHBOARD.BOOKING_SUMMARY')}
            </h3>
            <div className="input-section">
              <div className="month-picker-wraper">
                <input
                  max={maxMonth}
                  onChange={(event) => handleDateOnTable(event)}
                  className="month-picker-dashboard"
                  type="month"
                  value={monthInTable}
                />
                <div className="calender-image-container">
                  <img
                    width={24}
                    height={24}
                    src="/assets/calender.svg"
                    alt=""
                  />
                </div>
              </div>
              <form
                onSubmit={(event) => handleTableSearch(event)}
                className="table-search-input-section"
              >
                <Input
                  name="search"
                  className="input"
                  type="text"
                  placeholder="Search"
                  onChange={(event) => handleOnchange(event.target.value)}
                />
                <Button type="submit" className="button">
                  {' '}
                  <img
                    src="assets/search-logo.svg"
                    alt=""
                    width={18}
                    height={18}
                  />
                </Button>
              </form>
              <button
                style={{
                  border:
                    '1.55px solid var(--Color-Grey-200, #e1e7ec) !important',
                  borderRadius: '7px',
                  cursor: 'pointer',
                  background: '#ffffff ',
                  width: '40px',
                }}
                type="button"
                onClick={() =>
                  dispatch(
                    downloadTableData({
                      month: monthInTable,
                      searchTerm: tableSearch,
                      filter: tableFilter,
                      facilityId:
                        currentFacility?.id ||
                        (searchParams.get('f_id') as string),
                    })
                  )
                }
              >
                {!istableSummarydownloading ? (
                  <img
                    src="assets/download-logo.png"
                    alt=""
                    width={18}
                    height={18}
                  />
                ) : (
                  <Spinner color="secondary" size={'sm'} />
                )}
              </button>
            </div>
          </div>
          <div className="table-section">
            {!istableSummaryFetching ? (
              tableSummary?.data?.[0]?.payloads?.content?.length ? (
                <DashBoardTable
                  isPending={true}
                  data={tableSummary?.data[0]?.payloads?.content}
                  filter={tableFilter}
                  setFilter={setTableFilter}
                  setPage={setCurrentPage}
                />
              ) : (
                <NoDataBooking name="Data Available" />
              )
            ) : (
              <SectionLoader />
            )}
          </div>
          <div className="db-table-total-comm">
            <div className="db-commission-item">
              <h5>{translation('DASHBOARD.TOTAL_BOOKING_AMOUNT')}</h5>
              <h6>
                ${' '}
                {tableSummary?.data?.[0]?.totalEarnings
                  ? tableSummary?.data?.[0]?.totalEarnings.toFixed(2)
                  : '0.00'}
              </h6>
            </div>
            <div className="db-commission-item">
              <h5>{translation('DASHBOARD.AWAYTOGETHER_COMMISSION')}</h5>
              <h6>
                ${' '}
                {tableSummary?.data?.[0]?.totalAwayTogetherCommission
                  ? tableSummary?.data?.[0]?.totalAwayTogetherCommission.toFixed(
                      2
                    )
                  : '0.00'}
              </h6>
            </div>
            <div className="db-commission-item">
              <h5>{translation('DASHBOARD.TOTAL_FACILITY_COMMISSION')}</h5>
              <h6>
                ${' '}
                {tableSummary?.data?.[0]?.totalAwayTogetherFacilityCommission
                  ? tableSummary?.data?.[0]?.totalAwayTogetherFacilityCommission.toFixed(
                      2
                    )
                  : '0.00'}
              </h6>
            </div>
          </div>
          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            forcePage={currentPage}
            breakLabel={'...'}
            pageCount={
              tableSummary?.data[0]?.payloads?.totalPages
                ? tableSummary?.data[0]?.payloads?.totalPages
                : 0
            }
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            containerClassName={'dashboard-pagination'}
            pageClassName={'page-item pageButton-bg border-radius'}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            pageLinkClassName={
              'page-link pageButton-bg border-radius shadow-none'
            }
            previousLinkClassName={
              'page-link pageButton-bg border-radius shadow-none'
            }
            nextLinkClassName={
              'page-link pageButton-bg border-radius shadow-none'
            }
            breakClassName={'page-item pageButton-bg border-radius'}
            breakLinkClassName={'page-link pageButton-bg border-radius'}
            activeClassName={'active pageButton-active'}
          />
        </div>
      </Row>
    </div>
  );
};

export default Dashboard;
